export default {"src":"/_next/static/media/pdf-icon.05cd1e0e.svg","height":20,"width":20};